import { CONFIG_LAYOUTS } from "../constants.js";
const isConfig = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return config !== null;
};
const isConfigurationLayout = (val) => Object.values(CONFIG_LAYOUTS).includes(val);
const isConfiguration = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return config.id !== void 0 && (config.layout === void 0 || isConfigurationLayout(config.layout)) && config.report_endpoints !== void 0 && Array.isArray(config.report_endpoints) && config.report_endpoints.every((endpoint) => typeof endpoint === "object" && endpoint.uri !== void 0 && endpoint.method !== void 0 && (endpoint.params === void 0 || typeof endpoint.params === "object"));
};
export {
  isConfig,
  isConfiguration,
  isConfigurationLayout
};
